import React from 'react';
import CardLayout from '../../components/cards/CardLayout';
import CardBody from '../../components/cards/CardBody';
import CardFooter from '../../components/cards/CardFooter';
import PropTypes from 'prop-types';
import Button from '../button/Button';

const CardDelete = ({ pictureType, closeDelete, deletePicture }) => {
    return (
        <CardLayout title={`Delete ${pictureType} picture?`}>
            <CardBody variant="text_center" component="p" padding={3}>
                Are you sure you want to delete your {pictureType} picture?
            </CardBody>
            <CardBody mt={2} component="p" variant="center">
                You cannot undo this action.
            </CardBody>
            <CardFooter position="center">
                <Button
                    onClick={deletePicture}
                    text="Yes, Delete"
                    classs="btnMain"
                    fontSize="13px"
                />
                <Button
                    onClick={closeDelete}
                    text="Cancel"
                    classs="btnOutlineMain"
                    fontSize="13px"
                />
            </CardFooter>
        </CardLayout>
    );
};

CardDelete.propTypes = {
    pictureType: PropTypes.string,
    closeDelete: PropTypes.func,
    deletePicture: PropTypes.func
};

export default CardDelete;
